import { render, staticRenderFns } from "./WebhookInfo.vue?vue&type=template&id=2dcc42a0"
import script from "./WebhookInfo.vue?vue&type=script&lang=js"
export * from "./WebhookInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports